import { Field, useFormContext, Widget } from '@kanda-libs/ks-component-ts';
import { useMemo } from 'react';
import { EnquiryProjectBudgetFormValues } from '../useEnquiryProjectBudgetForm';
import { FINANCE_INTEREST_VALIDATION } from './constants';

const EnquiryProjectBudgetFormFieldsProjectBudgetInterestInCredit: React.FunctionComponent =
  function () {
    const { formState } = useFormContext<EnquiryProjectBudgetFormValues>();

    const errorObject = useMemo(() => formState.errors, [formState]);

    const keys = Object.keys(errorObject);

    const fieldError = useMemo(() => {
      if (!keys.includes('interest_in_credit')) return undefined;
      return errorObject.interest_in_credit;
    }, [keys, errorObject]);

    const error = useMemo(() => {
      if (!fieldError) return undefined;
      if (fieldError.type === 'required')
        return 'You must select whether you are interested in finance or not';
      return 'You must select whether you are interested in finance or not';
    }, [fieldError]);

    return (
      <div className="flex flex-col w-full">
        <Field.Validator validation={FINANCE_INTEREST_VALIDATION}>
          <Widget.InterestInCredit
            inline
            wrap
            variant="streamline-radio"
            label="Are you interested in applying for finance to fund this work?"
          />
        </Field.Validator>
        {error && <p className="-mt-2 mb-5 text-12-18 text-red-200">{error}</p>}
      </div>
    );
  };

export default EnquiryProjectBudgetFormFieldsProjectBudgetInterestInCredit;
